import '@/assets/style/normalize.css'
import '@/assets/style/element/index.css'
import '@/assets/style/index.scss'

import Vue from 'vue'
import ElementUI from 'element-ui'
import App from '@/view/App.vue'
import router from '@/view/router'
import store from '@/model/store/index'

import axios from 'axios'
import qs from 'qs'

import '@/view/components'

Vue.use(ElementUI, { size: 'mini' })

Vue.config.productionTip = false

window.a = axios
window.qs = qs
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
